module.exports = __webpack_public_path__ + "static/media/waiting-receipt.3e338d5c.svg";